// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"9f4efed5","415":"88f025ba","522":"92f3f5cf","631":"6fa12f6b","720":"709ed006"}[chunkId] + ".chunk.js";
};